import {useAnimatedPopper} from 'platform/components';
import {Box, HStack, Icon, VStack} from 'platform/foundation';

import {useRef} from 'react';

import {MenuItemProps, UserSidebarIconSize} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {useOutsideClick} from 'shared/web';

import {SIDEBAR_DESKTOP_ICON_SIZE} from '../constants/sidebarDesktopIconSize';
import {SIDEBAR_DESKTOP_MENU_ICON_SIZE} from '../constants/sidebarDesktopMenuIconSize';
import {MenuLink} from './MenuLink';
import {NavigationButton} from './NavigationButton';

export function SidebarOverflowMenu(props: {
  iconSize: UserSidebarIconSize;
  pinnedMenuItems: string[];
  menuItemsById: Record<string, MenuItemProps>;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const {togglePopper, closePopper, referenceRef, popperProps, Popper, isOpen} = useAnimatedPopper({
    placement: 'right-end',
    isOutsideClickIgnored: true,
    gutter: 8,
    autoUpdateOptions: 'default',
  });

  useOutsideClick({
    ref,
    enabled: isOpen,
    handler: () => {
      closePopper();
    },
  });

  return (
    <Box ref={ref}>
      <NavigationButton ref={referenceRef} onClick={togglePopper} isActive={isOpen}>
        <Icon
          color="text.white"
          size={SIDEBAR_DESKTOP_ICON_SIZE[props.iconSize]}
          value="navigation/more_vert"
        />
      </NavigationButton>
      <Popper {...popperProps}>
        <Box
          padding={2}
          borderRadius="medium"
          overflowY="auto"
          maxHeight="100vh"
          backgroundColor="palettes.neutral.900.100"
        >
          <VStack>
            {props.pinnedMenuItems.map((id) => {
              const menuItem = props.menuItemsById[id];
              if (!menuItem) {
                return null;
              }

              return (
                <MenuLink to={menuItem.path} key={menuItem.id}>
                  <HStack align="center" spacing={3}>
                    <Icon
                      size={SIDEBAR_DESKTOP_MENU_ICON_SIZE[props.iconSize]}
                      value={menuItem.layoutProps.icon}
                    />
                    {i18n.t(menuItem.layoutProps.title)}
                  </HStack>
                </MenuLink>
              );
            })}
          </VStack>
        </Box>
      </Popper>
    </Box>
  );
}
